import React, { useEffect, useState } from 'react';

const Referral = (props) => {
  const { url, title, description, image } = props;

  const [showImage, setShowImage] = useState(false);

  const referralContainer = React.createRef();

  useEffect(() => {
    if (showImage) return;
    const node = referralContainer.current;
    const observerCallback = (entries, observer) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        setShowImage(true);
        observer.unobserve(node);
      });
    };

    const observerOptions = {
      rootMargin: '500px',
      threshold: 0.1,
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);
    observer.observe(node);
    return () => {
      observer.unobserve(node);
    };
  }, [referralContainer, showImage]);

  return (
    <a href={url} target='_blank' rel='noreferrer'>
      <div className='referral-link clearfix' ref={referralContainer}>
        <figure>
          {showImage && (
            <img src={image} />
          )}
        </figure>
        <div className='referral-meta'>
          <h6>{title}</h6>
          <p>{description}</p>
        </div>
      </div>
    </a>
  );
};

export default Referral;
